import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { useState } from "react";
import { colors } from "../../../config/theme";
import { tdStyle, thStyle } from "../../../helpers/constants";
import { IconAction } from "../../../helpers/general";
import DeleteIcon from "../../icons/DeleteIcon";
import PromptModal from "../../modals/PromptModal";

interface ReviewTableProps {
  reviews: any[];
  handleDeleteReview: (id: string) => void;
  isDeletingReview: boolean;
}

export default function BookingReviewTable({
  reviews,
  handleDeleteReview,
  isDeletingReview,
}: ReviewTableProps) {
  const [reviewToDeleteId, setReviewToDeleteId] = useState<string | null>(null);

  const closeModal = () => setReviewToDeleteId(null);

  const confirmDelete = async () => {
    if (!reviewToDeleteId) return;
    await handleDeleteReview(reviewToDeleteId);
    closeModal();
  };

  return (
    <>
      <CTable responsive hover align="middle" className="mb-0">
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell style={thStyle}>Établissement</CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Date</CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Commentaire</CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Note</CTableHeaderCell>
            <CTableHeaderCell style={{ ...thStyle, textAlign: "right" }}>
              Actions
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {reviews.map((review) => (
            <CTableRow key={review.id}>
              <CTableDataCell style={tdStyle}>
                <span className="fw-semibold">{review.place_name}</span>
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                {new Date(review.review_createdAt).toLocaleDateString()}
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                {review.review_comment || "-"}
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                {review.review_rating}/5
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                <div className="d-flex align-items-center justify-content-end gap-2">
                  <IconAction
                    title="Supprimer"
                    danger
                    onClick={() => setReviewToDeleteId(review.review_id)}
                  >
                    <DeleteIcon width="18" height="18" fill={colors.primary} />
                  </IconAction>
                </div>
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>

      <PromptModal
        open={reviewToDeleteId !== null}
        onClose={closeModal}
        onAccept={confirmDelete}
        loading={isDeletingReview}
      />
    </>
  );
}
